import React from "react";
import { faTimesCircle, faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import { useRouter } from "next/navigation";

import Button from "@/components/button";
import { ButtonBar, Module } from "@/components/layouts";
import { ButtonGroup } from "@/components/layouts/button-group";
import { useModal } from "@/hooks/use-modal";

import ModalTitle from "./modal-title";

type ConfirmOverwriteAnimationModalProps = {
  onClearAndLoadSelected: () => void;
  onCancelSelected: () => void;
};

const ConfirmOverwriteAnimationModal = (
  props: ConfirmOverwriteAnimationModalProps,
) => {
  const { closeModal } = useModal();
  const router = useRouter();

  const onClearClicked = () => {
    props.onClearAndLoadSelected();
  };

  const onCancelClicked = () => {
    closeModal();
    router.replace("/editor");
    props.onCancelSelected();
  };

  return (
    <div>
      <ModalTitle>Clear Current Animation</ModalTitle>
      <Module>
        <p>You have an unsaved animation in the editor.</p>
        <p>Do you want to clear the editor and load this animation?</p>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faTrashAlt}
            onClick={onClearClicked}
            type="negative"
          >
            Clear and load
          </Button>
          <Button
            icon={faTimesCircle}
            onClick={onCancelClicked}
            type="positive"
          >
            Keep current
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
};

export default ConfirmOverwriteAnimationModal;
